<template>
	<!-- Desktop -->
	<div :class="['header', { expanded: isExpanded }]" v-if="!isMobile">
		<div class="top-container">
			<button class="logo" @click="goToPage('home')">
				<img :src="!isExpanded ? images.anagramaImage : images.logoImage" alt="Logo de BeePallet">
			</button>

			<p v-if="isLoggedIn && userName" class="user-name">Hola, <span>{{ userName }}</span></p>

			<button v-if="isLoggedIn && userName" class="menu-btn add-btn btn-outline btn-outline_green" @click="goToPage('create')">
				<i class="bp-icon-Plus"></i>
				<span>crear anuncio</span>
			</button>

			<ul class="menu-content">
				<div class="up-container">
					<li>
						<RouterLink :to="{name: 'home'}" class="menu-btn" :class="{ active: route.name === 'home'}">
							<i class="bp-icon-Store "></i>
							<span>Mercado</span>
						</RouterLink>
					</li>
					<li v-if="isLoggedIn && userName">
						<RouterLink :to="{name: 'my_listings'}" class="menu-btn" :class="{ active: route.name === 'my_listings'}">
							<i class="bp-icon-Catalog notification">
								<span v-if="totalListingNotifications > 0" class="notification-badge">{{totalListingNotifications}}</span>
							</i>
							<span>Mis anuncios</span>
						</RouterLink>
					</li>
					<li v-if="isLoggedIn && userName">
						<RouterLink :to="{name: 'bids'}" class="menu-btn" :class="{ active: route.name === 'bids'}">
							<i class="bp-icon-Bids notification">
								<span v-if="totalBidNotifcations > 0" class="notification-badge">{{totalBidNotifcations}}</span>
							</i>
							<span>Mis pujas</span>
						</RouterLink>
					</li>

					<li v-if="isLoggedIn && userName">
						<RouterLink :to="{name: 'order_list'}" class="menu-btn" :class="{ active: route.name === 'order_list'}">
							<i class="bp-icon-Orders notification">
								<span v-if="totalOrderMessageNotifcations > 0" class="notification-badge">{{totalOrderMessageNotifcations}}</span>
							</i>
							<span>Pedidos</span>
						</RouterLink>
					</li>
					<li v-if="isLoggedIn">
						<RouterLink :to="{name: 'customer_profile'}" class="menu-btn" :class="{ active: route.name === 'customer_profile'}">
							<i class="bp-icon-User">
							</i>
							<span>Mi cuenta</span>
						</RouterLink>
					</li>
					<li v-if="isLoggedIn">
						<button class="menu-btn" @click="logout">
							<i class="bp-icon-Log-out"></i>
							<span>Cerrar sesión</span>
						</button>
					</li>

					<li v-if="!isLoggedIn">
						<RouterLink :to="{name: 'login'}" class="menu-btn">
							<i class="bp-icon-User"></i>
							<span>Iniciar sesión</span>
						</RouterLink>
					</li>
				</div>

				<div class="down-container">
					<li>
						<a href="https://beepallet.com/blog/faq-preguntas-frecuentes/" class="menu-btn" target="_blank" rel="noopener noreferrer">
							<i class="bp-icon-FAQ"></i>
							<span>Preguntas frecuentes</span>
						</a>
					</li>
					<li v-if="!isLoggedIn">
						<a href="https://beepallet.com/blog/sobre-nosotros/" class="menu-btn" target="_blank" rel="noopener noreferrer">
							<i class="bp-icon-About-us"></i>
							<span>Sobre nosotros</span>
						</a>
					</li>
					<li v-if="!isLoggedIn">
						<a href="https://beepallet.com/blog/contacto/" class="menu-btn" target="_blank" rel="noopener noreferrer">
							<i class="bp-icon-Contact"></i>
							<span>Contáctanos</span>
						</a>
					</li>
				</div>
			</ul>
		</div>

		<button class="toggle-button" @click="toggleSidebar">
			<img :src="images.toggleMenuImg" alt="Icono doble chevron">
		</button>
	</div>

	<!-- Mobile -->
	<div class="header__mobile" v-else>
		<button :class="['menu-btn bp-icon-Burger', { hidden: showMobileMenu }]" @click="toggleMenu"></button>

		<RouterLink :to="{name: 'home'}" class="header__logo">
			<img :src="images.logoImage" alt="Logo BeePallet"  />
		</RouterLink>

		<button class="menu-btn add-btn-header btn-outline btn-outline_green bp-icon-Plus" v-if="!showMobileMenu && isLoggedIn" @click="goToPage('create')"></button>
		<button class="menu-btn bp-icon-Cross" @click="toggleMenu" v-else-if="showMobileMenu"></button>
		<button class="menu-btn add-btn-header btn-outline btn-outline_green bp-icon-User" @click="goToPage('login')" v-else-if="!showMobileMenu && !isLoggedIn"></button>

		<div :class="['header__mobile-menu', {show: showMobileMenu}]">
			<p v-if="isLoggedIn && userName" class="user-name">Hola, <span>{{ userName }}</span></p>
			<button class="menu-btn add-btn btn-outline btn-outline_green" v-if="isLoggedIn" @click="goToPage('create')">
				<i class="bp-icon-Plus"></i>
				<span>crear anuncio</span>
			</button>

			<ul class="menu-content" :class="{'logged': isLoggedIn}">
				<div class="up-container">
					<li>
						<button @click="goToPage('home')" class="menu-btn" :class="{ active: route.name === 'home'}">
							<i class="bp-icon-Store"></i>
							<span>Mercado</span>
						</button>
					</li>
					<li v-if="isLoggedIn">
						<button @click="goToPage('my_listings')" class="menu-btn" :class="{ active: route.name === 'my_listings'}">
							<i class="bp-icon-Catalog notification">
								<span v-if="totalListingNotifications > 0" class="notification-badge">{{totalListingNotifications}}</span>
							</i>
							<span>Mis anuncios</span>
						</button>
					</li>
					<li v-if="isLoggedIn">
						<button @click="goToPage('bids')" class="menu-btn" :class="{ active: route.name === 'bids'}">
							<i class="bp-icon-Bids notification">
								<span v-if="totalBidNotifcations > 0" class="notification-badge">{{totalBidNotifcations}}</span>
							</i>
							<span>Mis pujas</span>
						</button>
					</li>

					<li v-if="isLoggedIn">
						<button @click="goToPage('order_list')" class="menu-btn" :class="{ active: route.name === 'order_list'}">
							<i class="bp-icon-Orders notification">
								<span v-if="totalOrderMessageNotifcations > 0" class="notification-badge">{{totalOrderMessageNotifcations}}</span>
							</i>
							<span>Pedidos</span>
						</button>
					</li>
					<li v-if="isLoggedIn">
						<button @click="goToPage('customer_profile')" class="menu-btn" :class="{ active: route.name === 'customer_profile'}">
							<i class="bp-icon-User"></i>
							<span>Mi cuenta</span>
						</button>
					</li>
					<li v-if="isLoggedIn">
						<button class="menu-btn" @click="logout">
							<i class="bp-icon-Log-out"></i>
							<span>Cerrar sesión</span>
						</button>
					</li>
					<li v-if="!isLoggedIn">
						<button @click="goToPage('login')" class="menu-btn">
							<i class="bp-icon-User"></i>
							<span>Iniciar sesión</span>
						</button>
					</li>
				</div>
				<div class="down-container">
					<li>
						<a href="https://beepallet.com/blog/faq-preguntas-frecuentes/" class="menu-btn" target="_blank" rel="noopener">
							<i class="bp-icon-FAQ"></i>
							<span>Preguntas frecuentes</span>
						</a>
					</li>
					<li v-if="!isLoggedIn">
						<a href="https://beepallet.com/blog/sobre-nosotros/" class="menu-btn" target="_blank" rel="noopener">
							<i class="bp-icon-About-us"></i>
							<span>Sobre nosotros</span>
						</a>
					</li>
					<li v-if="!isLoggedIn">
						<a href="https://beepallet.com/blog/contacto/" class="menu-btn" target="_blank" rel="noopener">
							<i class="bp-icon-Contact"></i>
							<span>Contáctanos</span>
						</a>
					</li>
				</div>
			</ul>
		</div>

	</div>
</template>

<script setup lang="ts">
import {ref, onMounted, onBeforeUnmount, defineEmits, onBeforeMount, computed, watch} from 'vue';
import anagramaImage from '@/assets/images/BeePallet_Anagrama.svg';
import logoImage from '@/assets/images/BeePallet_Logo.svg';
import toggleMenuImg from '@/assets/images/Icons/Icon_toggle-menu.svg';
import iconPlus from '@/assets/images/Icons/Icon_Plus.svg';
import { useRouter, useRoute } from 'vue-router';
import * as Session from "supertokens-web-js/recipe/session";
import {LocalStorageService} from "@/services/backend/LocalStorageService";
import { isMobile, isTablet } from '@/helpers/CommonHelper';
import { showExceptionAlert, showWarningAlertWithConfirmation } from '@/helpers/SweetAlertHelper';
import { useStore } from 'vuex'


const store = useStore()
const emit = defineEmits(['expanded']);

const showMobileMenu = ref(false);
const isExpanded = ref(true);

// 🧠 replace with Vuex state
const isLoggedIn = computed(() => store.state.isUserLoggedIn)
const userName = computed(() => store.state.profile?.name ?? '')


const totalListingNotifications = computed(() => store.state.notifications.totalListingNotifications);
const totalBidNotifcations = computed(() => store.state.notifications.totalBidNotifications);
const totalOrderMessageNotifcations = computed(() => store.state.notifications.totalOrderMessageNotifications);

const fetchNotifications = () => {
	store.dispatch('notifications/fetchNotificationCounts');
};

const router = useRouter();
const route = useRoute();

const images = {
	anagramaImage,
	logoImage,
	toggleMenuImg,
	iconPlus,
};

const handleResize = () => {
	let size = window.innerWidth;
	isMobile.value = size <= 768;
	isTablet.value = size <=1024 && size > 768;
};

const toggleSidebar = () => {
	isExpanded.value = !isExpanded.value;
	emit('expanded', isExpanded.value);
};

const toggleMenu = () => {
	showMobileMenu.value = !showMobileMenu.value;
};

const goToPage = (routeName: string) => {
	router.push({ name: routeName })
	if(isMobile) toggleMenu();
};

const logout = async () => {
	try {
		showWarningAlertWithConfirmation(
			'Cerrar sesión',
			'¿Estás seguro de que quieres salir?',
			async () => {
				await Session.signOut();
				store.commit('resetStore');
				LocalStorageService.clearAll();
				window.location.reload();
			}),
			'Salir';
	}
	catch (error) {
		showExceptionAlert(error);
	}
};



onMounted(async () => {
	handleResize();
	window.addEventListener('resize', handleResize);
});

let pollInterval: number | null = null;

onBeforeMount(async () => {
	if (isLoggedIn.value) {
		fetchNotifications();
	}
});

watch(() => isLoggedIn.value, (isLoggedIn) => {
	if (isLoggedIn) {
		fetchNotifications();
		pollInterval = setInterval(fetchNotifications, 30000);
	} else if (pollInterval) {
		clearInterval(pollInterval);
		pollInterval = null;
	}
});


onBeforeUnmount(() => {
	if (pollInterval) {
		clearInterval(pollInterval);
	}
	window.removeEventListener('resize', handleResize);
});
</script>

<style lang="scss" scoped>
@import "HeaderComponent";
</style>